import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { Box, Button, styled, SxProps, Theme } from '@mui/material';
import * as React from 'react';

import useCopyClipboard from '../../../hooks/useCopyClipboard';
import { TableTooltip } from '../_components_/TableTooltip';

export interface IProps {
  children?: string | React.ReactNode | React.ReactNode[];
  value: string;
  disabled?: boolean;
  onClick?: (...args: any[]) => void;
  isVisible?: boolean;
  style?: SxProps<Theme>;
  orderOnClick?: () => void;
  tooltipText?: string;
  toastLabel?: string;
}

const StyledButton = styled(Button)(() => ({
  fontSize: 16,
  fontWeight: 400,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  marginTop: -5,
  gap: 4,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    '& .MuiSvgIcon-root': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));

export const CopyableButton: React.FC<IProps> = ({
  value,
  isVisible = false,
  children,
  disabled,
  style,
  onClick,
  tooltipText,
  toastLabel,
}) => {
  const { setCopied } = useCopyClipboard({ successDuration: 1000, toastDuration: 1000, label: toastLabel });

  const iconStyles = {
    width: 16,
    height: 16,
    marginLeft: '3px',
    transition: 'all 0.25s ease',
  };

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setCopied(value.toString());
      if (onClick) {
        onClick(event);
      }
    },
    [onClick, value, setCopied],
  );

  return (
    <StyledButton onClick={handleClick} disabled={disabled} disableRipple variant="text" sx={style}>
      {children}
      <TableTooltip title={tooltipText || ''}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <ContentCopyOutlinedIcon
            sx={{
              ...iconStyles,
              opacity: isVisible ? 1 : 0,
              transform: !isVisible ? `translateX(-100%)` : 'unset',
            }}
          />
        </Box>
      </TableTooltip>
    </StyledButton>
  );
};
